import { SetSprayEventWizardStepAction, SprayEventWizardStep } from './types';
import { SPRAY_EVENT_WIZARD_SET_STEP } from './constants';

export function setSprayEventWizardStep(
    step: SprayEventWizardStep
): SetSprayEventWizardStepAction {
    return {
        type: SPRAY_EVENT_WIZARD_SET_STEP,
        payload: step
    };
}
